import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { DocuploadComponent } from '../docupload/docupload.component';
import { DuplicateLicenseComponent } from '../duplicate-license/duplicate-license.component';
import { NewmemberService } from '../../services/newmember.service';
import { DialogService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import {DynamicDialogRef} from 'primeng/api';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-revokepage',
  templateUrl: './revokepage.component.html',
  styleUrls: ['./revokepage.component.css'],
  providers: [DialogService]
})
export class RevokepageComponent implements OnInit {

  constructor(private datePipe: DatePipe, public ref: DynamicDialogRef, public nms: NewmemberService, public messageService: MessageService, public confirmationService: ConfirmationService, public dialogService: DialogService) { }

  @ViewChild("supportDocuments") private supportDocuments: DocuploadComponent;
  @ViewChild("photo") private photo: DocuploadComponent;
  @ViewChild("photoId") private photoId: DocuploadComponent;
  @ViewChild("associate") private associate: DocuploadComponent;
  @Input() memberDetails;
  nameblock: RegExp = /^[^<>*!@#$_%+=~`^{};:.,&|?\[\]'"]+$/;
  blockSpecial: RegExp = /^[^0-9<>*!@#$_%+=~`^{}()-/\\;:.,&|?\[\]'"]*$/;
  onlyNum: RegExp = /^[0-9]*$/;
  alphaNumberic: RegExp = /[a-z0-9]/i;
  //pincode: RegExp = /[^(a-z)]{6}$/;
  // ([0-9]{6}|[0-9]{3}\s[0-9]{3}) ;
  pinCode: RegExp = /^[0-9]{6}$/;
  biForm: FormGroup;
  bi: any = {};
  BIverified: boolean;
  recordList: Object[] = [];
  selectedMid: any = {};
  biFormValid: boolean = true;
  BIverifiedNo: any;
  PMverifiedNo: any;
  inProgress: boolean = false;
  adonSpinner: boolean = false;
  hardStop: boolean = false;
  validateFailed: boolean = false;
  storeList: any;
  declDocumentType: string;
  declFileName: string;
  isDeclToUploaded: boolean = false;
  bdForm: FormGroup;
  bdFormValid: boolean = true;

  babForm: FormGroup;
  babFormValid: boolean = true;

  bamForm: FormGroup;
  bamFormValid: boolean = true;
  termAddonVerified: boolean = false;

  pmForm: FormGroup;
  pmFormValid: boolean = true;

  attested: boolean;

  PMverified: boolean;
  myform: FormGroup;
  mid: number;
  mstatus: string;
  mlid: string;

  marketCommunication: boolean = true;

  selectDate: Date;
  otpShowHide: boolean = false;
  showOrHide: boolean = false;
  showOrHideBI: boolean = false;
  otpShowHideBI: boolean = false;

  model: any = {};
  membername: string;
  index: number = 0;
  BDflag: boolean = true;
  draftFlag: boolean = false;
  agelimit: any;
  yearlimit: any;
  currentDate: any;
  yearRange: any;

  licenceType: Object[] = [];
  docType: Object[] = [];
  licenceList = [];
  selectedLicence = [];
  uploadedFiles: any = {};
  addonList: any = [];
  addonCardholderList: any = [];
  populateForm: any = {};
  bd: any = {};
  ba: any = {};
  pm: any = {};
  termVeified: boolean = false;
  today: any;
  eMaxLimit: any;
  adProgressBar: boolean = false;
  sbSpinner: boolean = false;
  licUpdate: boolean = false;
  pidExpiryDisable: boolean = false;
  mandatoryNeeded: boolean = false;
  regex: string;
  proof = [];
  cardCreateStatus: any;
  revokeCardId: any;
  pmStateList: any = [];
  pmCityList: any = [];
  pmCountyList: any = [];
  pmStateDropDisable: boolean = true;
  pmCityDropDisable: boolean = true;
  hardStopLicenseType = [];
  licenseVerify = [];
  thirdPartyCheck: string = "";

  ngOnInit() {
    this.BIverified = false;
    this.bd.businessLicenseParamsList = [];
    this.bd.taxExemption = false;
    this.bd.ownerNameNotVisible = false;
    this.ba.sameAsBusinessAddress = false;
    this.pm.isBusinessOwner = false;
    this.pm.cardHolderDocuments = [];
    this.attested = true;
    this.storeList = JSON.parse(localStorage.getItem("stores"));
    if (localStorage.getItem("storeId") && localStorage.getItem("storeId") != "") {
      this.bi.storeId = parseInt(localStorage.getItem("storeId"));
    }
    this.bi.marketCommunication = true;

    this.bdForm = new FormGroup({
      businesstype: new FormControl('', Validators.compose([
        Validators.required
      ])),
      businessName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      businessnature: new FormControl('', Validators.compose([
        Validators.required
      ])),
      Lic_0: new FormControl(),
      Lic_1: new FormControl(),
      Lic_2: new FormControl(),
      expiry_0: new FormControl(),
      expiry_1: new FormControl(),
      expiry_2: new FormControl(),
      state_0: new FormControl(),
      state_1: new FormControl(),
      state_2: new FormControl(),
      MultiSelect: new FormControl('', Validators.compose([
        Validators.required
      ])),
      isBusinessOwnerNameGiven: new FormControl(false),
      isTaxExemption: new FormControl(false),
    });
    this.pmForm = new FormGroup({
      firstName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      middleName: new FormControl(),
      lastName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mobile: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[5-9][0-9]{9}$')
      ])),
      dob: new FormControl('', Validators.compose([
        Validators.required
      ])),
      buildingno: new FormControl('', Validators.compose([
        Validators.required
      ])),
      streetname: new FormControl('', Validators.compose([
        Validators.required
      ])),
      city: new FormControl('', Validators.compose([
        Validators.required
      ])),
      state: new FormControl('', Validators.compose([
        Validators.required
      ])),
      pinno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ])),
      docType: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardLic: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardExpiry: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardState: new FormControl('', Validators.compose([
        Validators.required
      ])),
      county: new FormControl('', Validators.compose([
        Validators.required
      ])),
      STDLandLine: new FormControl(),
      whatsappNumber: new FormControl({ disabled: true }),
      mailId: new FormControl('', Validators.compose([
        Validators.pattern('^[A-Za-z0-9._-]+[@][A-Za-z0-9._-]+[.][a-zA-Z]{2,5}$')
      ])),
      education: new FormControl({ disabled: true }),
      income: new FormControl({ disabled: true }),
      social: new FormControl({ disabled: true }),
      isBusinessOwner: new FormControl(false),
      attestation: new FormControl({ value: false, disabled: true }),
      revokeChoice: new FormControl(),
      revokeAddon: new FormControl(),
    });
    this.pmForm.patchValue({'revokeChoice':'newPrimary'});
    if (this.memberDetails.cardHolderInfo != null) {
      for (let mem of this.memberDetails.cardHolderInfo) {
        if (mem.cardHolderType == 'A' && mem.status == 'A') {
          let tempObj = { "name": mem.firstName, "id": mem.cardHolderNbr };
          this.addonList.push(tempObj);
        } else if (mem.cardHolderType == 'P' && mem.status == 'A') {
          this.revokeCardId = mem.cardHolderNbr;
        }
        if (mem.cardHolderType == 'A' && (mem.status != 'L' && mem.status != 'R' && mem.status != 'S')) {
          this.addonCardholderList.push(mem);
        }
        
      }
      if (this.addonList.length != 0) {
        this.pmForm.patchValue({'revokeAddon':this.addonList[0].id});
      }
    }
    var date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    this.agelimit = date;
    this.currentDate = new Date();
    //this.currentDate.setDate( this.currentDate.setDate() + 1 );

    let temp = new Date();
    this.eMaxLimit = new Date(temp.setFullYear(temp.getFullYear() + 99));
    this.yearlimit = (this.agelimit.getFullYear() - 82) + ":" + this.agelimit.getFullYear();
    this.yearRange = this.currentDate.getFullYear() + ":" + this.eMaxLimit.getFullYear();
    this.termAddonVerified = true;
    this.termVeified = true;
    this.BIverified = true;
    this.resumeDraft();
    this.cardCreateStatus = [{ label: 'Active', value: 'A' }, { label: 'Draft', value: 'D' }];
  }

  resumeDraft() {
    this.nms.formFill().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        this.populateForm = res.response;
        var licenseType = this.populateForm.businessLicense.filter(proj => proj.code === "SCER");
        if (licenseType[0] != null) {
          licenseType[0].text = "SHOP AND COMMERCIAL ESTABLISHMENT REGISTRATION";
        }
        this.today = res.responseDateTime;
        this.nms.populateForm().subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            this.adProgressBar = false; // hide progress bar
            this.bi.firstName = res.response.firstName;
            this.bi.middleName = res.response.middleName;
            this.bi.lastName = res.response.lastName;
            this.bi.phoneNbr = res.response.phoneNbr;
            this.bi.storeId = res.response.storeId;
            this.bd.businessName = res.response.businessName;
            this.bd.segmentCode = res.response.segmentCode;
            this.bd.sicCode = res.response.sicCode;
            this.bd.taxExemption = res.response.taxExemption ? res.response.taxExemption : false;
            this.bd.ownerNameNotVisible = res.response.ownerNameNotVisible ? res.response.ownerNameNotVisible : false;
            this.bd.supportingDocuments = [];
           /* if (res.response.supportingDocuments != null) {
              this.bd.supportingDocuments = res.response.supportingDocuments;
              if (this.bd.supportingDocuments.length > 0) {
                this.declDocumentType = this.bd.supportingDocuments[0].documentType;
                this.isDeclToUploaded = true;
                this.uploadedFiles.supportingDocuments = [];
                let temp: any = this.bd.supportingDocuments[0];
                temp.ustatus = this.bd.supportingDocuments[0].documentId != null ? true : false;
                this.uploadedFiles.supportingDocuments[0] = temp;
              }
            }*/

            if (res.response.memberBusinessLicense) {
              this.bd.businessLicenseParamsList = res.response.memberBusinessLicense;
              this.selectedLicence = [];
              this.uploadedFiles.businessLicenseParamsList = [];
              let docUnavail = 0;
              for (let list of this.bd.businessLicenseParamsList) {
                if(!list.documentId) {
                  docUnavail = 1;
                }
                this.selectedLicence.push(list.licenseType);
                let temp: any = list;
                temp.documentType = list.licenseType;
                temp.ustatus = list.documentId != null ? true : false;;
                this.uploadedFiles.businessLicenseParamsList.push(temp);
                for (let list1 of this.populateForm.businessLicense) {
                  if (list1.code == list.licenseType) {
                    list.name = list1.text;
                    list.defaultExpiryYear = list1.defaultExpiryYear;
                    list.maxLength = list1.maxLength;
                  }
                }
                for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
                  if(this.bd.businessLicenseParamsList[i].maxLength > 0) {
                    this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+this.bd.businessLicenseParamsList[i].maxLength+'}$')]);
                  } else {
                    this.bdForm.get('Lic_' + i).setValidators([Validators.required]);
                  }
                }
              }
              if(docUnavail == 1) {
                this.mandatoryNeeded = true;
                this.licUpdate = true;
              }
            } else {
              this.mandatoryNeeded = true;
              this.licUpdate = true;
            }
            if (res.response.authorizationDocument) {
              this.bd.authorizationDocument = res.response.authorizationDocument;
              this.uploadedFiles.authorizationDocument = [];
              let temp: any = this.bd.authorizationDocument;
              temp.ustatus = this.bd.authorizationDocument.documentId != null ? true : false;
              this.uploadedFiles.authorizationDocument[0] = temp;
            }
            this.ba = res.response.memberAddresses != null ? res.response.memberAddresses : {};
            this.ddCheck();
          }
        }, err => {
          this.adProgressBar = false; // hide progress bar
          console.error('ERROR', err);
        });
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  btypeChange() {
    this.bd.sicCode = "";
    this.ddCheck();
  }

  isPhoneNumberUnique(phoneNbr, cardholderNbr) {
    if (this.addonCardholderList.length > 0) {
      var addOn = this.addonCardholderList.filter(proj => proj.phoneNbr === parseInt(phoneNbr));
      if (addOn[0] != null) {
        for (var index = 0; index < addOn.length; index++) {
          if (addOn[index].cardHolderNbr != '') {
            if (addOn[index].cardHolderNbr != cardholderNbr){
              this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Mobile number is already used by another card holder(' + addOn[index].firstName + '), please change the mobile number.' });
              return false;
            } else if (addOn[index].cardHolderNbr == cardholderNbr && addOn[index].phoneNbr == phoneNbr){
              this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Same mobile number cannot be updated.' });
              return false;
            }
          }
        }
      }
    } 
    return true;
  }

  contactInfo() {
    var otpInfo: any = {};
    otpInfo.phoneNbr = this.pm.phoneNbr;
    otpInfo.maMembershipId = this.nms.mlid;
    otpInfo.category = "ONBOARDING_OTP";
    return otpInfo;
  }

  ddCheck() {
   /* var isDeclarationChanged = false;
    var existingDocumentType = null;
    if (this.bd && this.bd.supportingDocuments && this.bd.supportingDocuments.length > 0) {
      existingDocumentType = this.bd.supportingDocuments[0].documentType;
    }
    var declarationDoc = this.populateForm.DeclarationDocuments;
    this.isDeclToUploaded = false;
    for (var docIndex in declarationDoc) {
      if (declarationDoc[docIndex].segmentCode == this.bd.segmentCode) {
        if (declarationDoc[docIndex].fileName != null) {
          this.declDocumentType = declarationDoc[docIndex].documentName;
          this.declFileName = declarationDoc[docIndex].fileName;
          this.isDeclToUploaded = true;
        } else if (declarationDoc[docIndex].licenseDeclarations != null) {
          var licenseDeclarations = declarationDoc[docIndex].licenseDeclarations;
          for (var declIndex in licenseDeclarations) {

            if (this.selectedLicence.indexOf(licenseDeclarations[declIndex].licenseType) > -1) {
              this.declDocumentType = licenseDeclarations[declIndex].documentName;
              this.declFileName = licenseDeclarations[declIndex].licFileName;
              this.isDeclToUploaded = true;
            }
          }
        }
        break;
      }
    }
    if (existingDocumentType != this.declDocumentType) {
      isDeclarationChanged = true;
    }
    if (isDeclarationChanged) {
      this.bd.supportingDocuments = [];
      this.uploadedFiles.supportingDocuments = [];
      // if (this.supportDocuments != null) {
      //   this.supportDocuments.reset();
      // }
    } */
  }

  ustatusUpdate(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
    } else {
      let check = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          check = 1;
          list.ustatus = event;
        }
      }
      if (check == 0) {
        this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
      }
    }
  }

  updateUploadstatus(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
    } else {
      let done = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          list.documentId = event.documentId;
          done = 1;
        }
      }
      if (done == 0) {
        this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
      }
    }
  }

  updateLicenceList(event) {
    var removeItem = 1;
    for (let val of event.value) {
      if (event.itemValue == val) {
        removeItem = 0;
      }
    }
    if (removeItem == 1) {
      var temp_obj = JSON.parse(JSON.stringify(this.bd.businessLicenseParamsList));
      this.bd.businessLicenseParamsList = [];
      for (var i = 0; i < temp_obj.length; i++) {
        if (temp_obj[i].licenseType == event.itemValue) {
          if (event.itemValue == "GST") {
            this.hardStopLicenseType["GST REGISTRATION"] = false;
          } else if (event.itemValue == "UAN") {
            this.hardStopLicenseType["UDYOG AADHAAR"] = false;
          }        
          temp_obj.splice(i, 1);
          this.proof[i] = 0;
          break;
        }
        /*if(temp_obj[i].expirationDate && temp_obj[i].expirationDate != '') {
          var date = new Date(temp_obj[i].expirationDate);
          var day = date.getDate();
          var monthIndex = date.getMonth();
          var year = date.getFullYear();
          temp_obj[i].expirationDate = year + '-' + monthIndex + '-' + day;
        }*/
      }
      for (var i = 0; i < temp_obj.length; i++) {
        if(temp_obj[i].expirationDate && temp_obj[i].expirationDate != '') {
          var date = new Date(temp_obj[i].expirationDate);
          var yestDateStr = this.datePipe.transform(date, 'yyyy-MM-dd');
          temp_obj[i].expirationDate = yestDateStr;
        }
      }
      this.bd.businessLicenseParamsList = temp_obj;
       
      this.bdForm.updateValueAndValidity();
      for (var index = 0; index < 3; index++) {
          this.bdForm.get('Lic_' + index).setValidators(null);
          this.bdForm.get('Lic_' + index).updateValueAndValidity();
      }

      for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
        let obj = {}
        obj['Lic_'+i] = this.bd.businessLicenseParamsList[i].licenseNumber?this.bd.businessLicenseParamsList[i].licenseNumber:'';
        obj['expiry_'+i] = this.bd.businessLicenseParamsList[i].expirationDate?this.bd.businessLicenseParamsList[i].expirationDate:'';
        obj['state_'+i] = this.bd.businessLicenseParamsList[i].stateProvCode?this.bd.businessLicenseParamsList[i].stateProvCode:'';        
        this.bdForm.patchValue(obj);
        this.bdForm.updateValueAndValidity();
        if(this.bd.businessLicenseParamsList[i].maxLength > 0) {
          this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+this.bd.businessLicenseParamsList[i].maxLength+'}$')]);
          this.bdForm.get('Lic_' + i).updateValueAndValidity();
        } else {
          this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]+$')]);
          this.bdForm.get('Lic_' + i).updateValueAndValidity();
        }
      }
      for(var i = 0; i < this.uploadedFiles['businessLicenseParamsList'].length; i++){
        if (this.uploadedFiles['businessLicenseParamsList'][i].documentType == event.itemValue) {          
          this.uploadedFiles['businessLicenseParamsList'].splice(i, 1);
          this.proof[i] = 0;
          break;
        }
      }
    } else {
      if (!this.isDeclToUploaded) {
        this.isDeclToUploaded = true;
      }
      for (let list of this.populateForm.businessLicense) {
        if (list.code == event.itemValue) {
          if (list.defaultExpiryYear > 0) {
            
            let currDate = new Date(localStorage.getItem('currDate'));
            let expDate = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
            this.bd.businessLicenseParamsList.push({ "name": list.text, "licenseType": list.code, "expirationDate": expDate, "defaultExpiryYear": list.defaultExpiryYear, "maxLength": list.maxLength });
          } else {
            
            this.bd.businessLicenseParamsList.push({ "name": list.text, "licenseType": list.code, "defaultExpiryYear": list.defaultExpiryYear, "maxLength": list.maxLength });
          }
          if(list.maxLength > 0) {
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).updateValueAndValidity();
          } else {
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).setValidators([Validators.required]);
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).updateValueAndValidity();
          }
        }
      }
      if (!this.uploadedFiles['businessLicenseParamsList']) {
        this.uploadedFiles['businessLicenseParamsList'] = [];
        this.uploadedFiles['businessLicenseParamsList'].push({ "ustatus": false, "documentType": event.itemValue });
      } else {
        let check = 0;
        for (let list of this.uploadedFiles['businessLicenseParamsList']) {
          if (list.documentType == event.itemValue) {
            check = 1;
            list.ustatus = false;
          }
        }
        if (check == 0) {
          this.uploadedFiles['businessLicenseParamsList'].push({ "ustatus": false, "documentType": event.itemValue });
        }
      }
    }
    this.ddCheck();
  }

  populateLicenceDetails(res, index, type) {
    if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
      this.hardStop = false;
      this.msgToast('Business name, License state and business address are populated using GSP service');
      this.bd.businessName = res.response.businessName;
      this.ba.businessAddressLine1 = res.response.addressLine1;
      this.ba.businessAddressLine2 = res.response.addressLine2;
      this.bd.businessLicenseParamsList[index].stateProvCode = "";
      this.ba.businessStateProvCode = "";
      this.ba.businessCityName = "";
      let stateFound = 0;
      let cityFound = 0;
      if (res.response.city == "") {
        cityFound = 1;
      }
      for (let l of this.populateForm.StateCityList) {
        if (l.stateName == res.response.state && stateFound == 0) {
          this.ba.businessStateProvCode = l.stateName;
          this.bd.businessLicenseParamsList[index].stateProvCode = l.stateName;
          stateFound = 1;
        }
        if (l.cityName == res.response.state && cityFound == 0) {
          this.ba.businessCityName = l.cityName
          cityFound = 1;
        }
        if (stateFound == 1 && cityFound == 1) {
          break;
        }
      }
      this.ba.businessPostalCode = res.response.pincode;
      this.hardStopLicenseType[type] = false;
    } else {
      this.hardStopLicenseType[type] = true;
    }
  }

  onChangeMethod(i) {
    this.proof[i] = 0;
  }

  onBlurMethod(type, index) {
    this.proof[index] = 0;
    if (type == "GST REGISTRATION" && this.bdForm.get('Lic_' + index).value.length == 15) {
      this.nms.validateGST(this.bdForm.get('Lic_' + index).value).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
         // if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
         //   this.proof[index] = "VALID";
        //  } else {
        //    this.proof[index] = "INVALID";
        //  }
          this.proof[index]=res.response.statusCode;
          this.licenseVerify['GST'] = res.response.statusCode;
          this.populateLicenceDetails(res, index, type);
        } else {
          this.licenseVerify['GST'] = 'RETRY_ERROR';
          this.validateFailed = true;
          this.proof[index] = "Failed";
          this.hardStopLicenseType[type] = true;
        }
      }, err => {
        this.licenseVerify['GST'] = 'RETRY_ERROR';
        this.validateFailed = true;
        this.proof[index] = "Failed";
        this.hardStopLicenseType[type] = true;
      });
    } else if (type == "UDYOG AADHAAR" && this.bdForm.get('Lic_' + index).value.length == 12) {
      this.nms.validateUAN(this.bdForm.get('Lic_' + index).value).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
          if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
            this.proof[index] = "VALID";
          } else {
            this.proof[index] = "INVALID";
          }
          this.populateLicenceDetails(res, index, type);
        } else {
          this.validateFailed = true;
          this.proof[index] = "Failed";
          this.hardStopLicenseType[type] = true;
        }
      }, err => {
        this.validateFailed = true;
        this.proof[index] = "Failed";
        this.hardStopLicenseType[type] = true;
      });
    }
  }

  retryValidation() {
    for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
      if (this.bd.businessLicenseParamsList[i].name == "GST REGISTRATION" || this.bd.businessLicenseParamsList[i].name == "UDYOG AADHAAR") {
        this.populateLicenceDetails(this.bd.businessLicenseParamsList[i].name, i, this.bd.businessLicenseParamsList[i].name);
      }
    }
  }

  mandatoryAlert() {
    this.msgToast('Please fill all mandatory fields');
  }

  msgToast(msg) {
    this.messageService.add({ severity: 'error', summary: 'Member Onboard', detail: msg });
  }

  newPrimary() {
    if (this.pmForm.get('revokeChoice').value != "newPrimary") {
      for (let mem of this.memberDetails.cardHolderInfo) {
        if (mem.cardHolderNbr == this.pmForm.get('revokeAddon').value) {
          this.pm = mem;
          
          this.pmStateList = [];
          this.pmCityList = [];
          this.pmCountyList = [];         
          
          this.pmStateList.push(this.pm.stateProvCode);          
          this.pmCityList.push(this.pm.cityName);
          this.getCountyByPincode(this.pm.postalCode);

          this.PMverified = true;
          this.PMverifiedNo = this.pm.phoneNbr;
          this.pm.cardHolderDocuments = [];
          this.uploadedFiles.cardHolderDocuments = [];
          for (let list of mem.cardHolderDocuments) {
            list.ustatus = list.documentId != null ? true : false;
            this.uploadedFiles.cardHolderDocuments.push(list);
          }
          this.PMverified = true;
        }
      }
      setTimeout(() => {
        this.photo.reinit();
        this.photoId.reinit();
      }, 500);
    } else {
      this.pm = {}
      setTimeout(() => {
        this.photo.reinit();
        this.photoId.reinit();
      }, 500);
    }
  }

  addonChange() {
    if (this.pmForm.get('revokeChoice').value != "newPrimary") {
      for (let mem of this.memberDetails.cardHolderInfo) {
        if (mem.cardHolderNbr == this.pmForm.get('revokeAddon').value) {
          this.pm = mem;
          this.pmStateList = [];
          this.pmCityList = [];
          this.pmCountyList = [];         
          
          this.pmStateList.push(this.pm.stateProvCode);          
          this.pmCityList.push(this.pm.cityName);
          this.getCountyByPincode(this.pm.postalCode);

          this.PMverified = true;
          this.PMverifiedNo = this.pm.phoneNbr;
          this.uploadedFiles.cardHolderDocuments = [];
          for (let list of mem.cardHolderDocuments) {
            list.ustatus = list.documentId != null ? true : false;
            this.uploadedFiles.cardHolderDocuments.push(list);
          }
          this.PMverified = true;
        }
      }
      setTimeout(() => {
        this.photo.reinit();
        this.photoId.reinit();
      }, 500);
    }
  }

  getCountyByPincode(pincode) {
    if (pincode != undefined && pincode.toString().length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {
        if (res.code === "SUCCESS") {
          this.pmCountyList = [];
          this.pmCountyList = res.response.countyNames;
          if (this.pmCountyList.indexOf(this.pm.countyName) < 0) {
            this.pmCountyList.push(this.pm.countyName);
          }
        } 
      });
    }
  }

  resetOTP(type) {
    if (type == 'bi') {
      this.BIverified = false;
      this.draftFlag = false;
      this.PMverified = false;
    } else {
      this.PMverified = false;
    }
    if (type == "bi") {
      if (this.BIverifiedNo == this.bi.phoneNbr) {
        this.BIverified = true;
        this.PMverified = true;
      }
    } else {
      if (this.PMverifiedNo == this.pm.phoneNbr) {
        this.PMverified = true;
      }
    }
  }

  updateOTPstatus(event, id) {
    if (id == "BIverified") {
      this.PMverified = event;
      this.PMverifiedNo = this.pm.phoneNbr;
    } else {
      this.PMverified = event;
      this.PMverifiedNo = this.pm.phoneNbr;
    }
  }

  updatePhotoId(event) {
    for (let list of this.populateForm.photoIdTypes) {
      if (list.code == event.value) {
        let currDate = new Date(localStorage.getItem('currDate'));
        this.pm.expirationDt = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
        if (list.defaultExpiryYear > 0) {
          this.pidExpiryDisable = true;
        } else {
          this.pidExpiryDisable = false;
          this.pm.expirationDt = '';
        }
        if(list.maxLength > 0) {
          this.pmForm.get('cardLic').setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
        } else {
          this.pmForm.get('cardLic').setValidators([Validators.required]);
        }
        break;
      }
    }
  }

  saveNewPrimary() {
    if (!this.isPhoneNumberUnique(this.pm.phoneNbr, this.pm.cardHolderNbr)){
      return;
    }
    if (this.pmForm.valid && this.PMverified) {
      if (this.uploadedFiles.cardHolderDocuments) {
        for (let list of this.uploadedFiles.cardHolderDocuments) {
          if (!list.ustatus) {
            this.pmFormValid = false;
            return;
          }
        }
        var photo = this.uploadedFiles.cardHolderDocuments.filter(proj => proj.documentType === "PHOTO");
        var photoProof = this.uploadedFiles.cardHolderDocuments.filter(proj => proj.documentType === "PHOTO PROOF");
        if (photo[0].length == 0 || photoProof.length == 0) {
          this.pmFormValid = false;
          return;
        }
      } else {
        this.pmFormValid = false;
        return;
      }
      if (this.pm.isBusinessOwner) {
        if (this.uploadedFiles.cardHolderDocuments.length < 3) {
          this.pmFormValid = false;
          return;
        }
      }
      if (this.uploadedFiles.cardHolderDocuments.length != 0) {
        this.uploadedFiles.cardHolderDocuments.forEach((list, i) => {
          if (list.documentType == "PHOTO") {
            this.pm.cardHolderDocuments[0] = list;
          } else if (list.documentType == "PHOTO PROOF") {
            this.pm.cardHolderDocuments[1] = list;
          } else if (list.documentType == "ASSOCIATED PROOF") {
            this.pm.cardHolderDocuments[2] = list;
          }
          if (!this.pm.isBusinessOwner && list.documentType == "ASSOCIATED PROOF") {
            this.uploadedFiles.cardHolderDocuments.splice(i, 1);
            this.pm.cardHolderDocuments.splice(i, 1);
          }
        });
      }
      if (this.licUpdate) {
        if (this.hardStopLicenseType["GST REGISTRATION"] || this.hardStopLicenseType["UDYOG AADHAAR"]) {
          this.hardStop = true;
        } else {
          this.hardStop = false;
        }
        if (this.bdForm.valid && !this.hardStop && !this.validateFailed) {
          for (let doc of this.bd.businessLicenseParamsList) {
            if ((!doc.licenseNumber || doc.licenseNumber == "") || (!doc.expirationDate || doc.expirationDate == "") || (!doc.stateProvCode || doc.stateProvCode == "")) {
              this.bdFormValid = false;
              this.mandatoryAlert();
              return;
            }
            if (this.uploadedFiles.businessLicenseParamsList) {
              for (let list of this.uploadedFiles.businessLicenseParamsList) {
                if (!list.ustatus) {
                  this.bdFormValid = false;
                  this.mandatoryAlert();
                  return;
                }
                if (list.documentType == doc.licenseType) {
                  doc.documentId = list.documentId;
                }
              }
            } else {
              this.bdFormValid = false;
              this.mandatoryAlert();
              return;
            }
          }
          if (this.bd.ownerNameNotVisible) {
            if (!this.uploadedFiles.authorizationDocument || !this.uploadedFiles.authorizationDocument[0].ustatus) {
              this.bdFormValid = false;
              return;
            }
            this.bd.authorizationDocument = this.uploadedFiles.authorizationDocument[0];
          } else {
            this.bd.authorizationDocument = {};
          }

          if (this.isDeclToUploaded) {
            if (!this.uploadedFiles.supportingDocuments || this.uploadedFiles.supportingDocuments.length == 0
              || !this.uploadedFiles.supportingDocuments[0].ustatus) {
              this.bdFormValid = false;
              return;
            }
            for (let supportin of this.uploadedFiles.supportingDocuments) {         
              if (supportin.documentType == "DECLARATION DOCUMENT") {
                if (!supportin.ustatus) {
                  this.bdFormValid = false;
                  return;
                }
                this.bd.supportingDocuments = [];
                this.bd.supportingDocuments.push(supportin);
              }
            }
          } else {
            this.bd.supportingDocuments = [];
          }
          this.revokePrimary("withLic");
        } else {
          if (this.hardStop) {
            this.confirmationService.confirm({
              message: "Invalid license number entered",
              acceptLabel: 'Ok',
              rejectVisible: false
            });
          } else if (this.validateFailed) {
            this.confirmationService.confirm({
              message: "License number validation failed",
              acceptLabel: 'Ignore',
              rejectLabel: 'Retry',
              accept: () => {
                this.validateFailed = false;
                this.revokePrimary("withLic");
              },
              reject: () => {
                this.retryValidation();
              }
            });
          } else {
            this.msgToast('Please fill all mandatory fields');
          }
          this.bdFormValid = false;
          this.sbSpinner = false;
        }
      } else {
        this.revokePrimary("withoutLic");
      }
    } else {
      this.pmFormValid = false;
      if (!this.pmForm.valid) {
        if (this.pmForm.get('mailId').valid) {
          this.msgToast('Please fill all mandatory fields');
        } else {
          this.msgToast('Invalid Email ID');
        }
      } else {
        this.msgToast('Mobile number not verified');
      }
    }

  }

  revokePrimary(process) {
    this.confirmationService.confirm({
      message: "Member will be moved to QC Pending status, Continue?",
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      accept: () => {
        let data;
        if (!this.pm.cardHolderNbr) {
          this.pm.cardHolderNbr = 0;
        }
        if (process = "withLic") {
          for (let doc of this.bd.businessLicenseParamsList){
            doc.thirdPartyCheck  = this.licenseVerify[doc.licenseType] ? this.licenseVerify[doc.licenseType] : doc.thirdPartyCheck ? doc.thirdPartyCheck : null;
          } 
          data = { "businessInfoParams": this.bd, "cardHolderInfo": this.pm }
        } else {
          data = { "businessInfoParams": null, "cardHolderInfo": this.pm }
        }
        data.primaryCardHolderNbr = this.revokeCardId;
        this.nms.revokePrimary(data).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            if (res.response.businessMembershipExist) {
              const ref = this.dialogService.open(DuplicateLicenseComponent, {
                data: res.response.duplicateMembership,
                header: 'Business License Already Exists',
                width: '50%',
                height: '80%',
                closeOnEscape: false
              });
              ref.onClose.subscribe((ignore) => {
                if (ignore){
                  this.ref.close(true);
                  this.msgToastInfo("Business License Already Exists, QC can be processed for this membership only by Store Admin.")
                }
              });
            } else {
              this.ref.close(true);
            }
            /*
            else if (res.response.isOCRValidated) {
              let popText: string;
              popText = '<div class="ocrPop"><div class="row"><div class="col-4"><h6>Document</h6></div><div class="col-4"><h6>Fields</h6></div><div class="col-4"><h6>Status</h6></div></div>';
              for (let list of res.response.memberBusinessLicense) {
                if (list.isLicenseNoOCRScreen != null || list.isBusinessNameOCRScreen != null || list.isDocumentNameOCRScreen != null) {
                  if (list.isLicenseNoOCRScreen == "false" || list.isBusinessNameOCRScreen == "false" || list.isDocumentNameOCRScreen == "false") {
                    let doc = "Match";
                    let bn = "Match";
                    let lic = "Match";
                    if (list.isLicenseNoOCRScreen == "false") { lic = 'Mismatch' }
                    if (list.isBusinessNameOCRScreen == "false") { bn = 'Mismatch' }
                    if (list.isDocumentNameOCRScreen == "false") { doc = 'Mismatch' }
                    popText = popText + '<div class="row"><div class="col-4">' + list.licenseType + '</div><div class="col-4"><div class="' + doc + '">Document</div><div class="' + bn + '">Business Name</div><div class="' + lic + '">License No</div></div>';
                    popText = popText + '<div class="col-4"><div class="' + doc + '">' + doc + '</div><div class="' + bn + '">' + bn + '</div><div class="' + lic + '">' + lic + '</div></div></div>';
                  }
                }
              }
              popText = popText + '</div>';
              this.confirmationService.confirm({
                message: popText,
                acceptLabel: 'Ignore',
                rejectLabel: 'Edit',
                accept: () => {
                  this.BDflag = false;
                  this.index = 1;
                }
              });
            } else {
              this.ref.close(true);
            }*/
          }
        }, err => {

        });
      }
    });
  }


  changeState(state) {

    this.pmCityList = [];

    this.nms.getCityByState(state).subscribe((res: any) => {
      if (res.code === "SUCCESS") {
        this.pmCityList = res.response;
      }
    });
  }

  changeCity(cityName) {
    this.pmCountyList = [];

    this.nms.getCountyListByCity(cityName).subscribe((res: any) => {
      if (res.code === "SUCCESS") {
        this.pmCountyList = res.response;
      }
    });
  }

  populateLocation(res) {
    this.pm.stateProvCode = "";
    this.pm.cityName = "";
    this.pmStateList = [];
    this.pmCityList = [];
    this.pm.countyName = "";
    this.pmCountyList = [];

    this.pmStateDropDisable = true;
    this.pmCityDropDisable = true;
    this.pmStateList.push(res.stateName);
    this.pm.stateProvCode = res.stateName;
    this.pmCityList.push(res.cityName);
    this.pm.cityName = res.cityName;
    this.pmCountyList = res.countyNames;
  }

  msgToastInfo(msg) {
    this.messageService.add({ severity: 'info', summary: 'Revoke Member', detail: msg });
  }

  getLocationByPincode(pincode, isDirty) {
    if (!isDirty) {
      return;
    }
    if (pincode && pincode.length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {

        if (res.code === "SUCCESS") {
          this.populateLocation(res.response);
        } else {
          this.messageService.add({ severity: 'info', summary: 'Primary Member Revoke', detail: 'Select State and City.' });
          this.pmStateList = [];
          this.pmCityList = [];
          this.pmCountyList = [];
          this.pmStateDropDisable = false;
          this.pmCityDropDisable = false;
          this.pm.cityName = "";
          this.pm.stateProvCode = "";
          this.pm.countyName = "";
          this.pmStateList = this.populateForm.states;

        }
      });
    }
  }
}
